import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RfidComponent } from './rfid.component';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';

import { RfidCardsTableComponent } from '@components/entities/rfid-cards/rfid-cards-table/rfid-cards-table.component';
import { UnassignedRfidCardsTableComponent } from '@components/entities/rfid-cards/unassigned-rfid-cards-table/unassigned-rfid-cards-table.component';
import { CreateRfidCardDialogComponent } from '@components/dialog/create-rfid-card-dialog/create-rfid-card-dialog.component';
import { EditRfidCardDialogComponent } from '@components/dialog/edit-rfid-card-dialog/edit-rfid-card-dialog.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'rfidcards', component: RfidComponent, canActivate: [AuthGuard, RoleGuard], data: { roles: ['Customer'] }, children: [
            {
              path: '',
              redirectTo: 'rfid',
              pathMatch: 'full'
            },
            {
              path: 'rfid',
              component: RfidCardsTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
            {
              path: 'unassigned-rfid',
              component: UnassignedRfidCardsTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateRfidCardDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: EditRfidCardDialogComponent
                }
              ]
            },
           
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class RfidModule { }
